import { memo } from "react";
import Image from "next/image";

const imgLoader = ({ src, width, quality }) => {
  return `${src}?width=${width}&quality=${quality || 100}&format=webp`;
};

export const ImgTag = memo(
  ({
    fetchpriority,
    src,
    alt,
    // maxWidthSrcset,
    srcSet,
    height,
    width,
    sizes,
    loading,
    className,
    ...props
  }) => {
    return (
      <Image
        className={className || ""}
        src={src}
        alt={alt}
        // srcSet={`${src} ${maxWidthSrcset || ""}`}
        srcSet={srcSet}
        fetchpriority={fetchpriority || "auto"}
        height={height}
        width={width}
        sizes={sizes}
        loading={loading || "lazy"}
        loader={imgLoader}
        role="img"
        {...props}
      />
    );
  }
);

ImgTag.displayName = "ImgTag";

export default ImgTag;

export const convertImg = (imgUrl, w, h) => {
  const first_part = imgUrl.split(".com/")[0];
  const last_part = imgUrl.split(".com/")[1];
  return `${first_part}.com/cdn-cgi/image/w=${w}&h=${h},fit=contain,format=auto,quality=75/${last_part}`;
};
